import { render, staticRenderFns } from "./SubFooter.vue?vue&type=template&id=1b3100f9&scoped=true&"
import script from "./SubFooter.vue?vue&type=script&lang=js&"
export * from "./SubFooter.vue?vue&type=script&lang=js&"
import style0 from "./SubFooter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SubFooter.vue?vue&type=style&index=1&id=1b3100f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3100f9",
  null
  
)

export default component.exports